import React from 'react';
import { AuthContext } from '../context/AuthContext';
import { AuthB2cContext } from '../../b2c/context/AuthB2cContext';

export function useAuth() {
  return React.useContext(AuthContext);
}

export function useB2cAuth() {
  return React.useContext(AuthB2cContext);
}
